import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  gap: 2rem;
  margin: 1rem 0;
  font-family: "Kanit";
  align-items: center;

  h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 300;
  }

  @media screen and (max-width: 750px) {
    flex-direction: column;
    gap: 1rem;
    h1 {
      font-size: 18px;
    }
  }
`;
